import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "@/context";

export function PublicRoute() {
  const { auth } = useAuth();
  const location = useLocation();

  if (auth.isAuthenticated) {
    if (location.state?.from)
      return <Navigate to={location.state.from || "/clients"} replace />;

    const publicRoutesToRedirect = ["/login", "/register", "/confirm-account"];
    if (location.pathname && publicRoutesToRedirect.includes(location.pathname))
      return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
